// extracted by mini-css-extract-plugin
module.exports = {"userSelect_none":"_32bbee5fda--userSelect_none--YJE8Q","userSelect_auto":"_32bbee5fda--userSelect_auto--WYbE7","userSelect_all":"_32bbee5fda--userSelect_all--JAOsx"};